import type { ReactNode } from "react";
import { FounderIconButton } from "./FounderIconButton";

type FounderEditDrawerProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
};

export function FounderEditDrawer({
  open,
  title,
  onClose,
  children,
  footer,
}: FounderEditDrawerProps) {
  if (!open) {
    return null;
  }

  return (
    <div className="oac-founder-drawer-root">
      <button
        aria-label="Close panel"
        className="oac-founder-drawer-root__backdrop"
        onClick={onClose}
        type="button"
      />
      <aside aria-label={title} className="oac-founder-drawer">
        <header className="oac-founder-drawer__head">
          <h2 className="oac-founder-drawer__title">{title}</h2>
          <FounderIconButton kind="cancel" label="Close" onClick={onClose} />
        </header>
        <div className="oac-founder-drawer__body">{children}</div>
        {footer ? <footer className="oac-founder-drawer__foot">{footer}</footer> : null}
      </aside>
    </div>
  );
}
